module.exports = __webpack_public_path__ + "img/icon-close-not-data.ebc62a09.png";